<div class="app-container" [class.no-bg]="noBg">
  <ng-content></ng-content>
</div>
